export default "__VITE_ASSET__CMql_6St__"